/**
 * NotFound Component Documentation
 *
 * This component serves as the 404 error page for the Silanga application.
 * It is displayed when a user tries to access a route that doesn't exist.
 *
 * Features:
 * 1. Clean and simple error page design
 * 2. Responsive layout that works on all screen sizes
 * 3. Clear error messaging
 * 4. Centered content for better user experience
 *
 * Usage:
 * This component should be used as a fallback route in the application's
 * routing configuration to handle undefined paths.
 */

import React from "react";
import { Box, Typography, Container } from "@mui/material";

/**
 * NotFound Component
 *
 * @returns {JSX.Element} The rendered 404 error page component
 */
const NotFound = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        {/* Large 404 error code display */}
        <Typography
          variant="h1"
          component="h1"
          gutterBottom
          sx={{ fontSize: "8rem", fontWeight: "bold" }}
        >
          404
        </Typography>
        {/* Error message */}
        <Typography variant="h5" component="h2">
          Page Not Found
        </Typography>
      </Box>
    </Container>
  );
};

export default NotFound;
